import Backbone from 'backbone/backbone'
import _ from 'underscore/underscore'

import BaseView from 'front/components/BaseView/BaseView.js'

import './Parallax.css'
import template from './Parallax.jinja'

const PARALLAX_START_SHIFT = 30


var Parallax = BaseView.extend({
    initialize () {
        _.bindAll(this, '_parallaxHandler')

        this.state = new Backbone.Model({
            parallax: false
        })

        this.$front = this.$('.Parallax-front')
        this.$back = this.$('.Parallax-back')

        this.$front.css({
            visibility: 'visible',
            //top: (this.$back.outerHeight() - app.els.$window.height()) + 'px'
            transform: 'translateY(' + (this.$back.outerHeight() - app.els.$window.height()) + 'px)'
        })

        this.parallaxHandler = _.throttle(this._parallaxHandler, 50)
        app.els.$window.on('scroll', this.parallaxHandler)
    },

    _parallaxHandler() {
        let bottomPos = app.els.$window.height() - PARALLAX_START_SHIFT
        let topElement = document.elementFromPoint(app.els.$window.width() / 2, bottomPos)

        if ($.contains(this.$back[0], topElement) && this.state.attributes.parallax) {
            this.state.set('parallax', false)
            this._disableParallax()
        } else if ($.contains(this.$front[0], topElement) && !this.state.attributes.parallax) {
            this.state.set('parallax', true)
            this._enableParallax()
        }
    },

    _enableParallax() {
        this.$back.css({
            position: 'fixed',
            //top: -app.els.$window.scrollTop() + 'px'
            transform: 'translateY(' + (-app.els.$window.scrollTop()) + 'px)'
        })
    },

    _disableParallax() {
        this.$back.css({
            position: 'absolute',
            //top: 0
            transform: 'translateY(0px)'
        })
    },

    close() {
        app.els.$window.off('scroll', this.parallaxHandler)
        BaseView.prototype.close.call(this)
    }
})

export default Parallax


// WEBPACK FOOTER //
// ./assets/app/front/components/Parallax/Parallax.js